module.exports = __webpack_public_path__ + "img/pic-2.d4a13163.png";